import { CommentCollectionItem } from 'Frontend/scripts/models/communityNews.model'
import { FunctionComponent, useEffect, useState } from 'react'
import Comment from './Comment'
import AddComment from './AddComment'
import { useScroll } from 'Frontend/hooks/useScroll'
import * as commentsService from 'Frontend/scripts/services/comments.services'

interface CommentsProps {
  contentId: string
}

const CommentsContainer: FunctionComponent<CommentsProps> = ({ contentId }) => {
  const { scrollToElement } = useScroll()
  const [commentCollection, setCommentCollection] = useState<CommentCollectionItem | null>(null)

  const getComments = (shouldScroll?: boolean) => {
    if (!contentId) return

    commentsService.getComments(parseInt(contentId)).then((collection) => {
      setCommentCollection(collection)
      shouldScroll && scrollToElement(`news-comments`)
    })
  }

  useEffect(() => {
    getComments()
  }, [])

  return (
    <div id="news-comments" className="p-4 bg-light">
      {commentCollection?.comments.map((comment) => (
        <Comment
          onPostDeleted={() => getComments()}
          hasCurrentUserAccessToDeleteComment={commentCollection.hasCurrentUserAccessToDeleteComment}
          key={comment.id.storeId}
          {...comment}
        />
      ))}
      <AddComment contentId={parseInt(contentId)} onPostAdded={() => getComments(true)} />
    </div>
  )
}

export default CommentsContainer
